"use strict";

(function ($, Drupal, window, document) {
  // OnReady
  $(function () {
    if ($('body').hasClass('taxonomy-term-page')) {
      var $win = $(window),
          $header = $('#content-header');
      $win.resize(function (event) {
        if ($win.width() < 1024) {
          $header.css({
            'right': '20px',
            'padding-left': '20px',
            'width': 'calc(100% + 40px)'
          });
        } else {
          // Reset the position and calculate the new ofset
          $header.css('right', 0);
          var offset = $header.offset().left;
          $header.css({
            'right': offset,
            'padding-left': offset,
            'width': $win.width()
          });
        }
      }); // Manually trigger the event the first time

      $win.resize();
    }
  });
})(jQuery, Drupal, window);